import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'lib/react-markdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ChecklistItem = ({ change, name, data, value, isLast }) => {
  const { text } = data || {};
  const icon = value ? ['fas', 'check-square'] : ['far', 'square'];
  const borderClass = isLast ? '' : 'border-bottom';

  return (
    <div
      className={`d-flex justify-content-left ${borderClass} pt-4`}
      onClick={e => change(name, e)}
      style={{ cursor: 'pointer' }}
    >
      <div className="px-3">
        <FontAwesomeIcon size="lg" icon={icon} color={value ? '#007BFF' : '#DDDDDD'} />
      </div>
      <div className="pr-3">
        <div>
          <ReactMarkdown>{text}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

ChecklistItem.propTypes = {
  change: PropTypes.func.isRequired,
  data: PropTypes.shape({
    text: PropTypes.string
  }),
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  isLast: PropTypes.bool
};

ChecklistItem.defaultProps = {
  data: { text: '' },
  value: false,
  isLast: false
};

export default ChecklistItem;
